import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

Vue.use(Vuetify)

const theme = {
  primary: '#E2AA12',
  secondary: '#E2AA12',
  accent: '#9C27b0',
  info: '#00CAE3',
  success: '#E2AA12',
  loginTitle: '#023A66',
  loginPlaceHolder: '#E2AA12',
  btnFloatColor: '#023A66',
  white: '#ffffff',
}

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
